import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Activity } from "lucide-react";

const ago = (iso) => {
  if (!iso) return "recently";
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

const Ticker = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/stats/corridors").then(r => setItems(r.data)).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <section className="border-y border-[var(--ra-border)] bg-[var(--ra-primary)]/[0.03]" data-testid="ticker">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center gap-4 overflow-hidden">
        <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-[var(--ra-primary)] font-semibold shrink-0">
          <Activity size={14} className="animate-pulse" /> Live transfers
        </div>
        <div className="flex gap-6 overflow-x-auto text-sm">
          {items.map((c, i) => (
            <div key={i} className="flex items-center gap-2 whitespace-nowrap" data-testid={`ticker-${i}`}>
              <span className="text-[var(--ra-muted)]">{ago(c.last_at)}:</span>
              <span>{c.source_flag} {c.source_currency} → {c.destination_flag} {c.destination_country}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ticker;
